import { backUrl } from "../utils/backURL";
import { apiFetch } from "../utils/apiFetch";

export const verifyEmail = async (verificationId) => {
    const signupReq = await apiFetch(`${backUrl}/email/verifyEmail`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            verificationId
        })
    });
    const signupRes = await signupReq.json();
    return signupRes;
};
